import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { logoutUser } from '../../redux/authSlice';
import { db } from '../../firebase';
import { collection, collectionGroup, onSnapshot } from 'firebase/firestore';
import SettingsModal from '../Profile/SettingsModal.jsx';
import useFullAccess from '../common/useFullAccess.js';
import UserAvatar from '../common/UserAvatar.jsx';
import logoGzi from '../../assets/gzi.jpg';
import './Header.css';

const Header = () => {
  const dispatch = useDispatch();
  const { isAuth, user } = useSelector((state) => state.auth);
  const [showSettings, setShowSettings] = useState(false);
  const fullAccess = useFullAccess();
  const [newPosts, setNewPosts] = useState(0);
  const [myGroups, setMyGroups] = useState([]);
  const [newGroupPosts, setNewGroupPosts] = useState(0);

  // Непрочитанные сообщения: сумма счётчиков unreadFrom
  const unreadMessages = user?.unreadFrom
    ? Object.values(user.unreadFrom).reduce((sum, n) => sum + (Number(n) || 0), 0)
    : 0;

  // Новые посты в ленте с момента последнего просмотра
  useEffect(() => {
    if (!user?.uid) return;
    const unsubscribe = onSnapshot(collection(db, 'posts'), (snap) => {
      const lastSeen = Number(localStorage.getItem('lastFeedSeen') || 0);
      let count = 0;
      snap.forEach((d) => {
        const p = d.data();
        const t = p.createdAt && p.createdAt.toMillis ? p.createdAt.toMillis() : 0;
        if (t > lastSeen) count++;
      });
      setNewPosts(count);
    });
    return () => unsubscribe();
  }, [user?.uid]);

  // Мои группы (где я участник)
  useEffect(() => {
    if (!user?.uid) { setMyGroups([]); return; }
    const unsubscribe = onSnapshot(collection(db, 'groups'), (snap) => {
      setMyGroups(
        snap.docs
          .map((d) => ({ id: d.id, ...d.data() }))
          .filter((g) => (g.members || []).includes(user.uid))
      );
    });
    return () => unsubscribe();
  }, [user?.uid]);

  // Новые посты в моих группах с последнего просмотра каждой
  useEffect(() => {
    if (!user?.uid || myGroups.length === 0) { setNewGroupPosts(0); return; }
    const ids = myGroups.map((g) => g.id);
    const unsubscribe = onSnapshot(collectionGroup(db, 'posts'), (snap) => {
      let count = 0;
      snap.forEach((d) => {
        const p = d.data();
        if (!p.groupId || !ids.includes(p.groupId)) return;
        const lastSeen = Number(localStorage.getItem('lastGroupSeen_' + p.groupId) || 0);
        const t = p.createdAt && p.createdAt.toMillis ? p.createdAt.toMillis() : 0;
        if (t > lastSeen) count++;
      });
      setNewGroupPosts(count);
    }, (error) => console.error('Ошибка счётчика групп:', error));
    return () => unsubscribe();
  }, [user?.uid, myGroups]);

  return (
    <header className="header">
           <div className="header-logo" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <img
          src={logoGzi}
          alt="ГЖИ"
          style={{ height: '36px', width: 'auto' }}
        />
        <h1 style={{ margin: 0 }}>ГЖИ Санкт-Петербурга</h1>
      </div>

      {isAuth && (
        <nav className="header-nav">
          <NavLink to="/profile" className={({ isActive }) => (isActive ? 'active' : '')} title="Профиль и лента">
            📰 <span className="nav-text">Профиль</span>
            {newPosts > 0 && <span className="nav-badge">{newPosts > 99 ? '99+' : newPosts}</span>}
          </NavLink>
          {fullAccess && (
            <NavLink to="/dialogs" className={({ isActive }) => (isActive ? 'active' : '')} title="Диалоги">
              💬 <span className="nav-text">Диалоги</span>
              {unreadMessages > 0 && <span className="nav-badge">{unreadMessages > 99 ? '99+' : unreadMessages}</span>}
            </NavLink>
          )}
          {fullAccess && (
            <NavLink to="/users" className={({ isActive }) => (isActive ? 'active' : '')} title="Пользователи">
              👥 <span className="nav-text">Пользователи</span>
            </NavLink>
          )}
          <NavLink to="/groups" className={({ isActive }) => (isActive ? 'active' : '')} title="Группы">
            🏘 <span className="nav-text">Группы</span>
            {newGroupPosts > 0 && <span className="nav-badge">{newGroupPosts > 99 ? '99+' : newGroupPosts}</span>}
          </NavLink>
                    <NavLink to="/fgis" className={({ isActive }) => (isActive ? 'active' : '')} title="ФГИС">
            📋 <span className="nav-text">ФГИС</span>
          </NavLink>
        </nav>
      )}

      <div className="header-user">
        {isAuth ? (
          <>
            <UserAvatar user={user} size={40} />
            <span className="user-name">{user?.displayName || user?.email?.split('@')[0]}</span>
            <button className="header-icon-btn" title="Настройки профиля" onClick={() => setShowSettings(true)}>⚙️</button>
            <button className="logout-btn" onClick={() => dispatch(logoutUser())}>Выйти</button>
          </>
        ) : (
          <span className="user-guest">Гость</span>
        )}
      </div>

      {showSettings && <SettingsModal user={user} onClose={() => setShowSettings(false)} />}
    </header>
  );
};

export default Header;